import handleCheckAccountOrTextChange from './handle-check-account-or-text-change'
import handleCheckAccountOrTextUpdate from './handle-check-account-or-text-update'
import handleCheckAttachmentChange from './handle-check-attachment-change'
import handleCheckGroupAttachmentChange from './handle-check-group-attachment-change'
import handleCheckGroupChange from './handle-check-group-change'

import initializeAccountsTable from './initialize-accounts-table'

export default function () {
  /**
   * TO-DO: The account widget deals with toggling checked state of various sets of inputs in unison, and across different tables.
   * This is a bit of a mess, and should be refactored to use a single JS state object instead of DOM reads.
   * Consider refactoring into a Vue component hierarchy, that given a certain state, prechecks the correct inputs, and updates the state when the user interacts with the inputs.
   * Leaving JQuery usage in place as this is going to get refactored anyway. JQuery usage on the new Vue component structure should be disallowed.
   * This would make it easier to understand, and easier to test.
   *  */
  const unsubscribers = [
    handleCheckAccountOrTextChange(),
    handleCheckAccountOrTextUpdate(),
    handleCheckAttachmentChange(),
    handleCheckGroupAttachmentChange(),
    handleCheckGroupChange(),
  ]

  initializeAccountsTable()

  return () => {
    unsubscribers.forEach((unsubscribe) => unsubscribe())
  }
}
